import styled from 'styled-components';

import Section from 'components/structure/Section';

export const StyledSection = styled(Section)`
  background-position-y: bottom;
`;

StyledSection.displayName = 'StyledSection';
